// import React from 'react';
// import styled from 'styled-components';

// const PageContainer = styled.div`
//     padding: 100px 20px;
//     max-width: 1200px;
//     margin: 0 auto;
// `;

// const HeroSection = styled.section`
//     text-align: center;
//     margin-bottom: 60px;
// `;

// const Title = styled.h1`
//     font-size: 3rem;
//     color: #1a2a6c;
//     margin-bottom: 20px;
//     text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
// `;

// const Subtitle = styled.p`
//     font-size: 1.2rem;
//     color: #2c3e50;
//     max-width: 800px;
//     margin: 0 auto;
//     line-height: 1.6;
// `;

// const ContentSection = styled.section`
//     display: grid;
//     grid-template-columns: 1fr 1fr;
//     gap: 40px;
//     margin-top: 40px;

//     @media (max-width: 768px) {
//         grid-template-columns: 1fr;
//     }
// `;

// const FeatureCard = styled.div`
//     background: #fff;
//     padding: 30px;
//     border-radius: 10px;
//     box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
//     transition: transform 0.3s ease;

//     &:hover {
//         transform: translateY(-5px);
//     }
// `;

// const FeatureTitle = styled.h2`
//     color: #1a2a6c;
//     margin-bottom: 15px;
//     font-size: 1.8rem;
// `;

// const FeatureDescription = styled.p`
//     color: #666;
//     line-height: 1.6;
//     margin-bottom: 20px;
// `;

// const TechStack = styled.div`
//     margin-top: 20px;
// `;

// const TechTitle = styled.h3`
//     color: #1a2a6c;
//     margin-bottom: 10px;
//     font-size: 1.2rem;
// `;

// const TechList = styled.div`
//     display: flex;
//     flex-wrap: wrap;
//     gap: 10px;
// `;

// const TechItem = styled.span`
//     background: #f0f2f5;
//     padding: 8px 16px;
//     border-radius: 20px;
//     color: #1a2a6c;
//     font-size: 0.9rem;
// `;

// const ITSecurity = () => {
//     return (
//         <PageContainer>
//             <HeroSection>
//                 <Title>IT Security Services</Title>
//                 <Subtitle>
//                     Protect your business with comprehensive security solutions designed to safeguard
//                     your digital assets and maintain business continuity.
//                 </Subtitle>
//             </HeroSection>

//             <ContentSection>
//                 <FeatureCard>
//                     <FeatureTitle>Network Security</FeatureTitle>
//                     <FeatureDescription>
//                         Advanced protection for your network infrastructure against cyber threats
//                         and unauthorized access.
//                     </FeatureDescription>
//                     <TechStack>
//                         <TechTitle>Security Solutions:</TechTitle>
//                         <TechList>
//                             <TechItem>Firewalls</TechItem>
//                             <TechItem>VPN</TechItem>
//                             <TechItem>Intrusion Detection</TechItem>
//                             <TechItem>Network Monitoring</TechItem>
//                             <TechItem>Access Control</TechItem>
//                         </TechList>
//                     </TechStack>
//                 </FeatureCard>

//                 <FeatureCard>
//                     <FeatureTitle>Endpoint Security</FeatureTitle>
//                     <FeatureDescription>
//                         Comprehensive protection for all devices connected to your network,
//                         ensuring secure operations across your organization.
//                     </FeatureDescription>
//                     <TechStack>
//                         <TechTitle>Protection Features:</TechTitle>
//                         <TechList>
//                             <TechItem>Antivirus</TechItem>
//                             <TechItem>Anti-malware</TechItem>
//                             <TechItem>Device Encryption</TechItem>
//                             <TechItem>Patch Management</TechItem>
//                             <TechItem>Mobile Security</TechItem>
//                         </TechList>
//                     </TechStack>
//                 </FeatureCard>

//                 <FeatureCard>
//                     <FeatureTitle>Security Assessment</FeatureTitle>
//                     <FeatureDescription>
//                         Regular security audits and vulnerability assessments to identify and
//                         address potential security risks.
//                     </FeatureDescription>
//                     <TechStack>
//                         <TechTitle>Assessment Services:</TechTitle>
//                         <TechList>
//                             <TechItem>Penetration Testing</TechItem>
//                             <TechItem>Vulnerability Scanning</TechItem>
//                             <TechItem>Risk Assessment</TechItem>
//                             <TechItem>Compliance Audits</TechItem>
//                             <TechItem>Security Consulting</TechItem>
//                         </TechList>
//                     </TechStack>
//                 </FeatureCard>

//                 <FeatureCard>
//                     <FeatureTitle>Security Operations</FeatureTitle>
//                     <FeatureDescription>
//                         24/7 monitoring and incident response to ensure continuous protection
//                         and rapid threat mitigation.
//                     </FeatureDescription>
//                     <TechStack>
//                         <TechTitle>Operations Services:</TechTitle>
//                         <TechList>
//                             <TechItem>SIEM</TechItem>
//                             <TechItem>Threat Intelligence</TechItem>
//                             <TechItem>Incident Response</TechItem>
//                             <TechItem>Security Analytics</TechItem>
//                             <TechItem>Managed Security</TechItem>
//                         </TechList>
//                     </TechStack>
//                 </FeatureCard>
//             </ContentSection>
//         </PageContainer>
//     );
// };

// export default ITSecurity; 



import React from 'react';
import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';
import { 
  FaShieldAlt, 
  FaNetworkWired, 
  FaLaptop, 
  FaSearch, 
  FaEye, 
  FaLock, 
  FaUserShield,
  FaBug,
  FaChartLine,
  FaClock,
  FaExclamationTriangle,
  FaMobileAlt,
  FaServer,
  FaCloud,
  FaDatabase,
  FaRocket
} from 'react-icons/fa';

// Animations
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const gradientShift = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
`;

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
`;

// Styled Components
const PageContainer = styled.div`
  padding: 120px 20px 80px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
  }
`;

const HeroSection = styled(motion.section)`
  text-align: center;
  margin-bottom: 80px;
  padding: 60px 40px;
  background: linear-gradient(135deg, var(--theme-hero-start) 0%, var(--theme-hero-end) 50%, var(--theme-hero-start) 100%);
  border-radius: 24px;
  color: #FFFFFF;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 40px var(--theme-shadow-accent);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(255, 200, 87, 0.1) 0%, transparent 50%);
    background-blend-mode: overlay;
  }

  @media (max-width: 768px) {
    padding: 40px 20px;
    margin-bottom: 60px;
  }
`;

const Title = styled.h1`
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 800;
  margin-bottom: 20px;
  letter-spacing: -0.02em;
  position: relative;
  z-index: 2;
  
  span {
    display: block;
    font-size: clamp(1rem, 2vw, 1.5rem);
    color: #FFC857;
    margin-top: 1rem;
    font-weight: 600;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    background: linear-gradient(135deg, #FFC857, #FF9F1C);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

const Subtitle = styled.p`
  font-size: clamp(1.1rem, 2vw, 1.4rem);
  color: rgba(244, 244, 244, 0.95);
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
  font-weight: 300;
  position: relative;
  z-index: 2;
`;

const ContentSection = styled(motion.section)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 40px;
  margin-top: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 25px;
  }
`;

const FeatureCard = styled(motion.div)`
  background: #ffffff;
  padding: 50px 40px;
  border-radius: 20px;
  box-shadow: 
    0 10px 30px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(0, 0, 0, 0.03);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  border-top: 4px solid var(--theme-accent);
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, var(--theme-accent-soft), transparent);
    transition: left 0.6s ease;
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 
      0 25px 50px -12px rgba(0, 0, 0, 0.15),
      0 0 0 1px rgba(0, 0, 0, 0.03);

    &::before {
      left: 100%;
    }

    .feature-icon {
      transform: scale(1.1);
      color: var(--theme-accent);
      animation: ${float} 3s ease-in-out infinite;
    }
  }

  @media (max-width: 768px) {
    padding: 40px 30px;
  }

  @media (max-width: 480px) {
    padding: 35px 25px;
  }
`;

const FeatureHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 25px;
`;

const FeatureIcon = styled.div`
  font-size: 3rem;
  color: var(--theme-primary);
  transition: all 0.4s ease;
  flex-shrink: 0;

  @media (max-width: 480px) {
    font-size: 2.5rem;
  }
`;

const FeatureTitle = styled.h2`
  color: var(--theme-primary);
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 1.2;

  @media (max-width: 480px) {
    font-size: 1.6rem;
  }
`;

const FeatureDescription = styled.p`
  color: #64748b;
  line-height: 1.7;
  margin-bottom: 25px;
  font-size: 1.05rem;
  font-weight: 400;
`;

const TechStack = styled.div`
  margin-top: 25px;
`;

const TechTitle = styled.h3`
  color: var(--theme-primary);
  margin-bottom: 15px;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const TechList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const TechItem = styled(motion.span)`
  background: var(--theme-surface-muted);
  color: var(--theme-primary);
  padding: 10px 18px;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 500;
  border: 1px solid var(--theme-border);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: var(--theme-accent-soft);
    color: var(--theme-accent);
    border-color: var(--theme-accent-soft);
    transform: translateY(-2px);
  }

  @media (max-width: 480px) {
    padding: 8px 14px;
    font-size: 0.85rem;
  }
`;

const SecurityLayersSection = styled(motion.section)`
  margin-top: 80px;
  padding: 60px 40px;
  background: linear-gradient(135deg, var(--theme-hero-start) 0%, var(--theme-hero-end) 100%);
  border-radius: 24px;
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='m0 40l40-40h-40v40zm40 0v-40h-40l40 40z'/%3E%3C/g%3E%3C/svg%3E");
  }

  @media (max-width: 768px) {
    padding: 40px 20px;
    margin-top: 60px;
  }
`;

const SectionTitle = styled.h2`
  font-size: clamp(2rem, 4vw, 3rem);
  color: #FFFFFF;
  margin-bottom: 50px;
  position: relative;
  z-index: 2;
  font-weight: 800;
  letter-spacing: -0.02em;
`;

const LayersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const LayerCard = styled(motion.div)`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 30px 25px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-5px);
  }

  @media (max-width: 480px) {
    padding: 25px 20px;
  }
`;

const LayerIcon = styled.div`
  font-size: 2.5rem;
  color: #FFC857;
  margin-bottom: 20px;
`;

const LayerTitle = styled.h3`
  color: #FFC857;
  margin-bottom: 15px;
  font-size: 1.3rem;
  font-weight: 600;
`;

const LayerDescription = styled.p`
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  font-size: 1rem;
`;

const CTAButton = styled(motion.a)`
  background: linear-gradient(135deg, #FFC857, #FF9F1C);
  color: var(--theme-primary);
  padding: 1.2rem 3rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 700;
  font-size: 1.1rem;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 
    0 8px 25px rgba(255, 200, 87, 0.3),
    inset 0 1px 0 rgba(255,255,255,0.3);
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  margin-top: 50px;
  letter-spacing: 0.5px;
  border: none;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 
      0 12px 30px rgba(255, 200, 87, 0.4),
      inset 0 1px 0 rgba(255,255,255,0.3);
    
    &::before {
      left: 100%;
    }
  }

  @media (max-width: 480px) {
    padding: 1rem 2.5rem;
    font-size: 1rem;
    margin-top: 40px;
  }
`;

const ComplianceSection = styled(motion.section)`
  margin-top: 80px;
  padding: 60px 40px;
  background: #ffffff;
  border-radius: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  text-align: center;

  @media (max-width: 768px) {
    padding: 40px 20px;
    margin-top: 60px;
  }
`;

const ComplianceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 40px;
  margin-top: 40px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 25px;
  }
`;

const ComplianceCard = styled(motion.div)`
  background: #f8fafc;
  padding: 40px 30px;
  border-radius: 16px;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    background: #ffffff;
    border-color: var(--theme-accent);
    transform: translateY(-5px);
    box-shadow: 0 10px 25px var(--theme-shadow-accent);
  }

  @media (max-width: 480px) {
    padding: 30px 20px;
  }
`;

const ComplianceIcon = styled.div`
  font-size: 3rem;
  color: var(--theme-primary);
  margin-bottom: 20px;
`;

const ComplianceName = styled.h3`
  color: var(--theme-primary);
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 10px;
`;

const ComplianceDescription = styled.p`
  color: #64748b;
  font-size: 0.95rem;
  line-height: 1.5;
`;

const ITSecurity = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        }
    };

    return (
        <PageContainer>
            <HeroSection
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <Title variants={itemVariants}>
                    IT Security Services
                    <span>Comprehensive Protection</span>
                </Title>
                <Subtitle variants={itemVariants}>
                    Protect your business with comprehensive security solutions designed to safeguard
                    your digital assets and maintain business continuity. Stay ahead of threats with
                    our advanced security framework.
                </Subtitle>
            </HeroSection>

            <ContentSection
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <FeatureCard
                    variants={itemVariants}
                    whileHover={{ y: -5 }}
                >
                    <FeatureHeader>
                        <FeatureIcon className="feature-icon">
                            <FaNetworkWired />
                        </FeatureIcon>
                        <FeatureTitle>Network Security</FeatureTitle>
                    </FeatureHeader>
                    <FeatureDescription>
                        Advanced protection for your network infrastructure against cyber threats
                        and unauthorized access. We implement multi-layered defense mechanisms
                        to secure your network perimeter and internal communications.
                    </FeatureDescription>
                    <TechStack>
                        <TechTitle>
                            <FaNetworkWired />
                            Security Solutions
                        </TechTitle>
                        <TechList>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaLock /> Firewalls
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                VPN
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaEye /> Intrusion Detection
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Network Monitoring
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaUserShield /> Access Control
                            </TechItem>
                        </TechList>
                    </TechStack>
                </FeatureCard>

                <FeatureCard
                    variants={itemVariants}
                    whileHover={{ y: -5 }}
                >
                    <FeatureHeader>
                        <FeatureIcon className="feature-icon">
                            <FaLaptop />
                        </FeatureIcon>
                        <FeatureTitle>Endpoint Security</FeatureTitle>
                    </FeatureHeader>
                    <FeatureDescription>
                        Comprehensive protection for all devices connected to your network,
                        ensuring secure operations across your organization. Protect desktops,
                        laptops, and mobile devices from advanced threats.
                    </FeatureDescription>
                    <TechStack>
                        <TechTitle>
                            <FaLaptop />
                            Protection Features
                        </TechTitle>
                        <TechList>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaShieldAlt /> Antivirus
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Anti-malware
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaLock /> Device Encryption
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Patch Management
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaMobileAlt /> Mobile Security
                            </TechItem>
                        </TechList>
                    </TechStack>
                </FeatureCard>

                <FeatureCard
                    variants={itemVariants}
                    whileHover={{ y: -5 }}
                >
                    <FeatureHeader>
                        <FeatureIcon className="feature-icon">
                            <FaSearch />
                        </FeatureIcon>
                        <FeatureTitle>Security Assessment</FeatureTitle>
                    </FeatureHeader>
                    <FeatureDescription>
                        Regular security audits and vulnerability assessments to identify and
                        address potential security risks. Our comprehensive assessments help
                        you understand and mitigate security vulnerabilities.
                    </FeatureDescription>
                    <TechStack>
                        <TechTitle>
                            <FaSearch />
                            Assessment Services
                        </TechTitle>
                        <TechList>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaBug /> Penetration Testing
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Vulnerability Scanning
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaExclamationTriangle /> Risk Assessment
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Compliance Audits
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Security Consulting
                            </TechItem>
                        </TechList>
                    </TechStack>
                </FeatureCard>

                <FeatureCard
                    variants={itemVariants}
                    whileHover={{ y: -5 }}
                >
                    <FeatureHeader>
                        <FeatureIcon className="feature-icon">
                            <FaEye />
                        </FeatureIcon>
                        <FeatureTitle>Security Operations</FeatureTitle>
                    </FeatureHeader>
                    <FeatureDescription>
                        24/7 monitoring and incident response to ensure continuous protection
                        and rapid threat mitigation. Our security operations center provides
                        real-time threat detection and response capabilities.
                    </FeatureDescription>
                    <TechStack>
                        <TechTitle>
                            <FaEye />
                            Operations Services
                        </TechTitle>
                        <TechList>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                SIEM
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Threat Intelligence
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                Incident Response
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaChartLine /> Security Analytics
                            </TechItem>
                            <TechItem whileHover={{ scale: 1.05 }}>
                                <FaClock /> Managed Security
                            </TechItem>
                        </TechList>
                    </TechStack>
                </FeatureCard>
            </ContentSection>

            <ComplianceSection
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <SectionTitle style={{ color: 'var(--theme-primary)' }} variants={itemVariants}>
                    Security Compliance & Standards
                </SectionTitle>
                <ComplianceGrid>
                    <ComplianceCard variants={itemVariants} whileHover={{ y: -5 }}>
                        <ComplianceIcon>
                            <FaShieldAlt />
                        </ComplianceIcon>
                        <ComplianceName>ISO 27001</ComplianceName>
                        <ComplianceDescription>
                            International standard for information security management systems
                        </ComplianceDescription>
                    </ComplianceCard>
                    <ComplianceCard variants={itemVariants} whileHover={{ y: -5 }}>
                        <ComplianceIcon>
                            <FaUserShield />
                        </ComplianceIcon>
                        <ComplianceName>GDPR Compliance</ComplianceName>
                        <ComplianceDescription>
                            Data protection and privacy for European Union citizens
                        </ComplianceDescription>
                    </ComplianceCard>
                    <ComplianceCard variants={itemVariants} whileHover={{ y: -5 }}>
                        <ComplianceIcon>
                            <FaServer />
                        </ComplianceIcon>
                        <ComplianceName>HIPAA</ComplianceName>
                        <ComplianceDescription>
                            Healthcare information privacy and security standards
                        </ComplianceDescription>
                    </ComplianceCard>
                    <ComplianceCard variants={itemVariants} whileHover={{ y: -5 }}>
                        <ComplianceIcon>
                            <FaCloud />
                        </ComplianceIcon>
                        <ComplianceName>SOC 2</ComplianceName>
                        <ComplianceDescription>
                            Trust services criteria for service organizations
                        </ComplianceDescription>
                    </ComplianceCard>
                </ComplianceGrid>
            </ComplianceSection>

            <SecurityLayersSection
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <SectionTitle variants={itemVariants}>
                    Multi-Layered Security Approach
                </SectionTitle>
                <LayersGrid>
                    <LayerCard variants={itemVariants}>
                        <LayerIcon>
                            <FaNetworkWired />
                        </LayerIcon>
                        <LayerTitle>Perimeter Security</LayerTitle>
                        <LayerDescription>
                            Firewalls, VPNs, and network segmentation to protect your external boundaries
                        </LayerDescription>
                    </LayerCard>
                    <LayerCard variants={itemVariants}>
                        <LayerIcon>
                            <FaDatabase />
                        </LayerIcon>
                        <LayerTitle>Data Protection</LayerTitle>
                        <LayerDescription>
                            Encryption, access controls, and data loss prevention to safeguard sensitive information
                        </LayerDescription>
                    </LayerCard>
                    <LayerCard variants={itemVariants}>
                        <LayerIcon>
                            <FaUserShield />
                        </LayerIcon>
                        <LayerTitle>Identity Management</LayerTitle>
                        <LayerDescription>
                            Multi-factor authentication and privileged access management for secure access
                        </LayerDescription>
                    </LayerCard>
                    <LayerCard variants={itemVariants}>
                        <LayerIcon>
                            <FaEye />
                        </LayerIcon>
                        <LayerTitle>Continuous Monitoring</LayerTitle>
                        <LayerDescription>
                            24/7 threat detection, security analytics, and real-time incident response
                        </LayerDescription>
                    </LayerCard>
                </LayersGrid>
                
                <CTAButton 
                    href="/contact"
                    variants={itemVariants}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    Secure Your Business
                    <FaShieldAlt />
                </CTAButton>
            </SecurityLayersSection>
        </PageContainer>
    );
};

export default ITSecurity;
